import { Component, OnInit, ViewChild } from '@angular/core';
import { PwcIconsLibrary, piInfo } from '@pwc-bei/icons';
import { ModalComponent } from '@pwc-bei/ui';
import { first } from 'rxjs/operators';
import { ServiceRequestService } from 'src/app/pages/service-requests/services/service-request.service';
import { CustomerProfileService } from 'src/app/pages/services/customer-profile.service';
import { UserProfile } from 'src/app/pages/user-profile/models/user-profile';

@Component({
    selector: 'app-journey',
    templateUrl: './journey.component.html',
    styleUrls: ['./journey.component.scss'],
    standalone: false
})
export class JourneyComponent implements OnInit{
  //number of step in the journey
  nStep = 9;

  showInfoJourney = true;
  listOfStep = Array.from(Array(this.nStep).keys());

  status: number = 0;

  @ViewChild('infoJourneyModal') infoJourneyModal: ModalComponent;

  constructor(
    private pwcIconsLibrary: PwcIconsLibrary,
    private serviceRequestSrv: ServiceRequestService,
    private customerProfileService: CustomerProfileService,
  ) {
    this.pwcIconsLibrary.registerIcons([piInfo]);
  }

  ngOnInit(): void {
    this.customerProfileService.getMyProfile().pipe(first())
    .subscribe((profile: UserProfile) => {
      this.serviceRequestSrv.getStatus(profile.id).pipe(first())
      .subscribe((st: number) => {
        this.status = st;
      });
    });

  }



  public isCurrent(step: number): Boolean {
    return step == this.status ? true : false;
  }

  public isComplete(step: number): Boolean {
    return step < this.status ? true : false;
  }

  // $("#advance").on("click", function() {
  //   var $bar = $(".ProgressBar");
  //   if ($bar.children(".is-current").length > 0) {
  //     $bar.children(".is-current").removeClass("is-current").addClass("is-complete").next().addClass("is-current");
  //   } else {
  //     $bar.children().first().addClass("is-current");
  //   }
  // });

  // $("#previous").on("click", function() {
  //   var $bar = $(".ProgressBar");
  //   if ($bar.children(".is-current").length > 0) {
  //     $bar.children(".is-current").removeClass("is-current").prev().removeClass("is-complete").addClass("is-current");
  //   } else {
  //     $bar.children(".is-complete").last().removeClass("is-complete").addClass("is-current");
  //   }
  // });
}
